import history from 'components/MainRouter/history';

export const signIn = () => {
  history.push(`/signin`);
};
